// src/theme/colors.ts
export const colors = {
  light: {
    logo: '#009AA4',
    primary: '#39A4E6',
    primaryContrast: '#665B4D',
    primaryContrastText: '#ffffff',
    primaryHover: '#3C3935',
    primaryPress: '#332D25',
    primaryText: '#ffffff', //
    primaryBorder: '#39A4E6',
    secondary: '#86C1E6', //
    secondaryContrast: '#86C1E6',
    secondaryContrastText: '#86C1E6',
    secondaryHover: '#86C1E6',
    secondaryPress: '#86C1E6',
    secondaryText: '#000000', //
    secondaryBorder: '#86C1E6',
    neutral: '#f8fafc', //
    neutralContrast: '#ffffff', //
    neutralContrastText: '#000000', //
    neutralHover: '#ffffff',
    neutralPress: '#ffffff',
    neutralText: '#000000',
    neutralBorder: '#e2e8f0',
    error: '#fee2e2',
    danger: '#ff6262',
    warning: '#f59e0b',
    success: '#62dd62',
    info: '#3b82f6',
  },
  dark: {
    logo: '#4E6061',

    // Accent principal (lisible sur fond sombre)
    neutral: '#0f172a', // slate-900 (fond)
    neutralContrast: '#1e293b', // surface élevée (cartes/panels)
    neutralContrastText: '#e5e7eb',
    neutralHover: '#0b1220', // hover du fond
    neutralPress: '#020617', // slate-950 (press)
    neutralText: '#e5e7eb',
    neutralBorder: '#334155', // slate-700 (bordures)

    // Secondary (tinted neutral for chips/badges)
    secondary: '#64748b', // slate-500
    secondaryContrast: '#475569', // slate-600
    secondaryContrastText: '#e5e7eb',
    secondaryHover: '#4b5563', // ~gray-600/slate-600
    secondaryPress: '#334155', // slate-700
    secondaryText: '#e2e8f0',
    secondaryBorder: '#475569',

    // Primaire bleu marque (lisible sur fond sombre)
    primary: '#39A4E6',
    primaryContrast: '#2286c8',
    primaryContrastText: '#ffffff',
    primaryHover: '#2286c8',
    primaryPress: '#1a6aa0',
    primaryText: '#ffffff',
    primaryBorder: '#39A4E6',

    // États (accessibles sur fond sombre)
    error: '#ff6262',
    danger: '#ef4444',
    warning: '#f59e0b',
    success: '#22c55e',
    info: '#4E88cc',
  },

  // Add other themes here if needed
};
